import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { ApolloClient, HttpLink, InMemoryCache, split } from "@apollo/client";

import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { ApolloProvider } from "@apollo/client/react";
import { RecoilRoot } from "recoil";

// The benign "ResizeObserver loop completed with undelivered notifications"
// warning (emitted by Ant Design's resize-based components) trips the dev error
// overlay. Root-cause fix: defer the ResizeObserver callback by one frame so a
// resize handler that mutates layout can't re-trigger a notification within the
// same frame — which is what produces the "undelivered notifications" error.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || entries.length) callback(entries, observer);
        });
      });
    }
  };
}

// Fallback: if the error still surfaces, swallow only this specific message and
// remove the webpack-dev-server overlay node it drew. Real errors pass through.
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (overlay) overlay.remove();
  }
});

const token = localStorage.getItem("token") || "";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_HASURA_GRAPHQL,
  headers: {
    authorization: `Bearer ${token}`,
    // 'x-hasura-admin-secret': "secret
  },
  credentials: "include",
});

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_WS_HASURA_GRAPHQL,
  options: {
    reconnect: true,
    connectionParams: {
      headers: {
        authorization: `Bearer ${token}`,
        // 'x-hasura-admin-secret': "secret
      },
    },
  },
});

/** Combine http and ws links */
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

/** apollo client */
const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <RecoilRoot>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </RecoilRoot>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
